import styled from 'styled-components'

import { FormStatus, ObservationStatus, ProjectFileStatus, TaskStatus } from '@types'

export const TimelineContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Wrapper = styled.div`
  flex: 1;
  padding-bottom: 12px;
  display: flex;
  align-items: center;
`

export const ActivityWrapper = styled(Wrapper)``

export const CommentWrapper = styled(Wrapper)`
  margin-left: -8px;
`

export const ActionText = styled.span<{ bold?: boolean }>`
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: #4d5874;

  font-weight: ${({ bold }) => (bold ? 500 : 400)};
  color: ${({ bold }) => (bold ? '#14171f' : '#4d5874')};
`

export const Bullet = styled.div`
  background-color: #8893a8;
  width: 4px;
  height: 4px;
  border-radius: 50%;
`

export const TextContent = styled.div`
  display: flex;
  justify-content: start;
  gap: 5px;
  align-items: center;

  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    gap: 3px;

    ${Bullet} {
      display: none;
    }
  }
`

export const WriteCommentContainer = styled.div`
  display: flex;
  border: 1px solid #bbc1d3;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
`

export const StatusIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  border: 2px solid var(--Persistent-White, #fff);
  box-sizing: border-box;

  width: 20px;
  height: 20px;
`

export const FormStatusIcon = styled(StatusIcon)<{ status: FormStatus }>`
  background: ${({ status }) =>
    status == FormStatus.StatusDone ? '#2FB609' : status == FormStatus.StatusInProgress ? '#FF8F00' : 'transparent'};
`

export const TaskStatusIcon = styled(StatusIcon)<{ status: TaskStatus }>`
  background: ${({ status }) =>
    status == TaskStatus.StatusDone
      ? '#2FB609'
      : status == TaskStatus.StatusWarning
      ? '#EB4747'
      : status == TaskStatus.StatusInProgress
      ? '#FF8F00'
      : 'white'};
`

export const ObservationStatusIcon = styled(StatusIcon)<{ status: ObservationStatus }>`
  background: ${({ status }) => {
    switch (status) {
      case ObservationStatus.StatusContested:
      case ObservationStatus.StatusPlannedRecovery:
        return '#EB4747'
      case ObservationStatus.StatusValidatedByReader:
        return '#FF8F00'
      case ObservationStatus.StatusValidatedByCustomer:
        return '#4D4BE7'
      case ObservationStatus.StatusValidatedByAdmin:
        return '#2FB609'
      default:
        return 'transparent'
    }
  }};
`

export const ProjectStatusIcon = styled(StatusIcon)<{ status: ProjectFileStatus | 'AVAILABLE' }>`
  background: ${({ status }) => {
    switch (status) {
      case ProjectFileStatus.Refused:
        return '#EB4747'
      case ProjectFileStatus.Pending:
        return '#FF8F00'
      case ProjectFileStatus.Validated:
        return '#2FB609'
      case ProjectFileStatus.ValidatedWithObservation:
        return '#4D5874'
      default:
        return 'transparent'
    }
  }};
`

export const ProjectFileAvailableIcon = styled.div`
  min-width: 14px;
  min-height: 14px;

  border: 2px solid #5a58f2;
  border-radius: 50%;
`
